import React from 'react';
import { useLocale } from '../../localization/LocaleContext';
import './CreditExplainer.css';

export default function CreditExplainer() {
    const { t } = useLocale();

    return (
        <section className="sp-90">
            <div className="container">
                <div className="credit-explainer">
                    <h2 className="h-2 h-bold credit-explainer-heading">
                        {t('credits.heading')}
                    </h2>
                    <p className="credit-explainer-subheading">
                        {t('credits.subheading')}
                    </p>

                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="credit-highlight-card">
                                <div className="credit-highlight-icons">
                                    <div className="credit-highlight-icon">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                                            <circle cx="12" cy="13" r="4"/>
                                        </svg>
                                    </div>
                                    <div className="credit-highlight-arrow">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#27c492" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <line x1="5" y1="12" x2="19" y2="12"/>
                                            <polyline points="12 5 19 12 12 19"/>
                                        </svg>
                                    </div>
                                    <div className="credit-highlight-icon credit-highlight-icon-invoice">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                            <polyline points="14 2 14 8 20 8"/>
                                            <line x1="16" y1="13" x2="8" y2="13"/>
                                            <line x1="16" y1="17" x2="8" y2="17"/>
                                            <polyline points="10 9 9 9 8 9"/>
                                        </svg>
                                    </div>
                                </div>
                                <h3 className="credit-highlight-title">
                                    {t('credits.oneCredit')}
                                </h3>
                                <p className="credit-highlight-desc">
                                    {t('credits.oneCreditDescription')}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="credit-example">
                                {t('credits.example')}
                            </div>
                        </div>
                    </div>

                    <div className="credit-comparison">
                        <h4>{t('credits.comparisonTitle')}</h4>
                        <div className="credit-plan-badges">
                            <div className="credit-plan-badge">
                                <p className="credit-plan-badge-name">{t('pricing.plans.free.name')}</p>
                                <p className="credit-plan-badge-value">{t('credits.free')}</p>
                            </div>
                            <div className="credit-plan-badge">
                                <p className="credit-plan-badge-name">{t('pricing.plans.premium.name')}</p>
                                <p className="credit-plan-badge-value">{t('credits.premium')}</p>
                            </div>
                            <div className="credit-plan-badge">
                                <p className="credit-plan-badge-name">{t('pricing.plans.ultimate.name')}</p>
                                <p className="credit-plan-badge-value">{t('credits.ultimate')}</p>
                            </div>
                        </div>
                        <p className="credit-renewal-note">{t('credits.renewalNote')}</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
